<div class="row card">
  <div class="card-header heading pad-horizontal-20">
    <span class="icon-claims margin-right-10"></span>
    <span> {{ sectionHeader }}</span>
  </div>

  <div class="pad-10">
    <div class="row pad-horizontal-10 sm-pad-horizontal-50 pad-vertical-10 sm-pad-vertical-30">
      <div class="column twelve pad-left-40 pad-right-20">
        <p class="text-gray pad-bottom-30">
          The coverages in this section apply to all your vehicles and can't be adjusted here. Your
          agent can change these for you.
        </p>
      </div>
    </div>
    @for (model of coverages?.coverages; track model) {
      <div class="row pad-horizontal-10 sm-pad-horizontal-50 pad-vertical-10 sm-pad-vertical-30">
        <div class="column twelve md-six pad-left-40 pad-right-20">
          <h2 class="coverage-heading">{{ model?.coverage?.description }}</h2>
          <p>
            {{ model?.subHeading }}
          </p>
        </div>
        <div class="column twelve sm-six pad-horizontal-40 pad-vertical-10 sm-pad-vertical-30">
          <div class="term">
            @if (model.coverage.code === 'PAEmergencyRoadServiceCov_af') {
              <p>Included</p>
            }
            @if (model.coverage.code !== 'PAEmergencyRoadServiceCov_af') {
              @for (term of model?.coverage?.limitTerms; track term) {
                <p>{{ term | term }}</p>
              }
              @if (
                !!model?.isStandardCoverage &&
                !(model?.isImpliedCoverage || model?.isLiabilityCoverage)
              ) {
                <div></div>
              }
              @for (term of model?.coverage?.deductibleTerms; track term) {
                <p>{{ term | term }}</p>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
